import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, isCRUDRights, Rights, RightsCrud } from '../../../services/auth.service';
import { defaultErrorHandler } from '../../../services/backend-caller.service';

export interface MenuItem {
  title: string;
  path: string;
  rightsName?: keyof Rights;
  children?: MenuItem[];
  icon?: string;
  collapsed?: boolean;
}

export const menuItems: MenuItem[] = [
  {
    title: 'События',
    path: 'violations',
    rightsName: 'violation',
    icon: 'assets/index-images/event.svg'
  },
  {
    title: 'Настройки доступа',
    path: 'access-settings',
    icon: 'assets/index-images/key.svg',
    collapsed: false,
    children: [
      {
        title: 'Сотрудники',
        path: 'employees',
        rightsName: 'employee',
        icon: 'assets/index-images/worker.svg'
      },
      {
        title: 'Пользователи',
        path: 'users',
        rightsName: 'user',
        icon: 'assets/index-images/user.svg'
      },
    ]
  },
  {
    title: 'Подразделения',
    path: 'departments-settings',
    icon: 'assets/index-images/dep-settings.svg',
    collapsed: false,
    children: [
      {
        title: 'Участки',
        path: 'departments',
        rightsName: 'department',
        icon: 'assets/index-images/group.svg'
      },
      {
        title: 'Зоны',
        path: 'zones',
        rightsName: 'zone',
        icon: 'assets/index-images/zone.svg'
      },
      {
        title: 'Камеры',
        path: 'cameras',
        rightsName: 'camera',
        icon: 'assets/index-images/cam.svg'
      },
    ]
  },
  {
    title: 'Конфигурация',
    path: 'configuration',
    icon: 'assets/index-images/config.svg',
    collapsed: false,
    children: [
      {
        title: 'Правила',
        path: 'rules',
        rightsName: 'rule',
        icon: 'assets/index-images/equipment.svg'
      },
      {
        title: 'Санкции',
        path: 'violation-sanctions',
        rightsName: 'violation-sanction',
        icon: 'assets/index-images/sanction.svg'
      }
    ]
  },
];



@Component({
  selector: 's-ori-navigation-sidebar',
  templateUrl: './ori-navigation-sidebar.component.html',
  styleUrls: ['./ori-navigation-sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class OriNavigationSidebarComponent implements OnInit {
  public visibleItems: MenuItem[] = [];

  @Input()
  public sidebarClosingMode: boolean;

  @Output()
  public sidebarClosingModeChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  public constructor(private authService: AuthService,
                      private router: Router) {
  }

  public ngOnInit() {
    this.authService.getRights()
      .pipe(defaultErrorHandler('Не удалось получить права пользователя'))
      .subscribe((rights: Rights) => {
        this.visibleItems = menuItems.filter(item => {
          if (item.children) {
            const visibleChilds = item.children.filter((child: MenuItem) => {
              return this.isVisible(child, rights);
            });
            if (visibleChilds.length !== 0) {
              item.children = visibleChilds;
              return true;
            } else {
              return false;
            }
          } else {
            return this.isVisible(item, rights);
          }
        });
      });
  }

  public isVisible(item: MenuItem, rights: Rights): boolean {
    const rightsForService = rights[item.rightsName];
    const crudRights = isCRUDRights(rightsForService) ? rightsForService : new RightsCrud();
    return crudRights && crudRights.see;
  }

  public openChild(childPath: string, parentPath: string, event: MouseEvent) {
    event.stopPropagation();
    this.router.navigate([`/${parentPath}/${childPath}`]);
  }

  public onModeChange(value: boolean) {
    this.sidebarClosingMode = value;
    this.sidebarClosingModeChange.emit(value);
  }
}
